import { render, staticRenderFns } from "./ShopCatalog.vue?vue&type=template&id=e056b022&scoped=true&"
import script from "./ShopCatalog.vue?vue&type=script&lang=js&"
export * from "./ShopCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ShopCatalog.vue?vue&type=style&index=0&id=e056b022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e056b022",
  null
  
)

export default component.exports